export default __webpack_public_path__ + "static/media/email-checked.48adaf90.png";